import { render, staticRenderFns } from "./AnnotateModal.vue?vue&type=template&id=596c1da4&scoped=true"
import script from "./AnnotateModal.vue?vue&type=script&lang=js"
export * from "./AnnotateModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "596c1da4",
  null
  
)

export default component.exports